import styled from 'styled-components';
import { dynamicFontSize } from './helpers/mixins';

export const ProductVariant = styled.div`
  ${dynamicFontSize(8, 12)};
  position: absolute;
  top: 10px;
  right: 8px;
  color: #a7a7a7;
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 1.5px;

  @media (min-width: 640px) {
    top: 11px;
    right: 11px;
  }
`;



// WEBPACK FOOTER //
// ./src/styles/ProductVariant.js